import React from 'react'

const Quote = ({text}) => {
    return (
        <p id="quote"> {text} </p>
    )
}

export default Quote